import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Input, InputGroup, Panel, Text } from 'rsuite';
import { MdOutlineCheck as IconConfirm, MdOutlineEdit as IconEdit } from 'react-icons/md';

import { COLOURS } from '../styles';
import { DisplayIcon } from './DisplayIcon';
import { DisplayIconNoBorder } from './DisplayIconNoBorder';
import { devLog } from '../utils/devLog';

export const DisplayNameInputItem = ({
  register,
  tc = /** @type {any} */ (undefined),
  icon = /** @type {any} */ (undefined),
  onChange,
  borderOff = false,
}) => {
  const [value, setValue] = useState('');
  const [disabled, setDisabled] = useState(true);

  // const mask =  [/.+ /, /.+ /, /.+ /, /.+ /,/.+ /, /.+ /, /.+ /, /.+ /,/.+ /, /.+ /, /.+ /, /.+ /,/.+ /, /.+ /, /.+ /, /.+ /];
  const updateValue = () => {
    if (disabled) {
      setDisabled(false);
    } else {
      setDisabled(true);
      onChange(register, value);
      devLog('name change', value);
    }
  };

  useEffect(() => {
    if (register.display !== undefined) {
      setValue(register.display);
    }
  }, [register.display]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div
          style={{
            display: 'block',
            width: '40%',
          }}
          className="truncate"
        >
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc ?? COLOURS.default} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '60%',
          }}
        >
          <InputGroup inside>
            <Input
              value={value}
              // mask={mask}
              disabled={disabled}
              // placeholderChar = " "
              onChange={setValue}
              maxLength={17}
            />
            <InputGroup.Button onClick={updateValue}>
              <DisplayIconNoBorder icon={disabled ? IconEdit : IconConfirm} />
            </InputGroup.Button>
          </InputGroup>
        </div>
      </Flex>
    </Panel>
  );
};
